// Tabs of the sales cards (Пр6): an order shows its items, tickets, payments and revisions; a ticket — who held it and its replacements; a company — its partnerships.
import { LinkedTable, type RecordTab } from '@confdeck/core-web';

const tab = (key: string, label: string, field: string, columns: string[], empty: string): RecordTab => ({
  key, label, field, component: ({ recordId }) => <LinkedTable recordId={recordId} field={field} columns={columns} empty={empty} />,
});

export const orderTabs: RecordTab[] = [
  tab('items', 'Позиции', 'items', ['title', 'offer', 'qty', 'price', 'amount'], 'Позиций нет'),
  tab('tickets', 'Билеты', 'tickets', ['number', 'name', 'email', 'status', 'checked_in_at'], 'Билетов нет'),
  tab('payments', 'Платежи', 'payments', ['title', 'amount', 'method', 'status', 'paid_at'], 'Платежей нет'),
  // Not «История»: that is the core's feed of every record (R-U22); these are the order's own revisions (R-T4).
  tab('revisions', 'Изменения', 'revisions', ['version', 'reason', 'total'], 'Изменений нет'),
];

export const ticketTabs: RecordTab[] = [
  tab('assignments', 'Назначения', 'assignments', ['contact', 'status', 'via', 'opened_at', 'closed_at'], 'Билет никому не назначен'),
  tab('replacements', 'Замены', 'replacements', ['title', 'status', 'old_participant', 'new_name', 'new_email'], 'Замен не было'),
];

/** A company's partnerships, one per event (um/2026-10-30/03 п.4): partners are companies, the level and the package live here (R-B1). */
export const companyTabs: RecordTab[] = [
  tab('partnerships', 'Партнёрства', 'partnerships', ['title', 'event', 'level', 'package', 'payment', 'published'], 'Компания не партнёр ни одного события'),
];
